Ext.ns('mx.Util');

mx.Util.displayError = function(text, title) {
    Ext.Msg.show({
        title: 'Error ' + title ? title : '',
        msg: text,
        icon: Ext.Msg.ERROR,
        buttons: Ext.Msg.OK,
    });
};

mx.Util.displayQuestion = function(text, title, callback, scope) {
    Ext.Msg.show({
        title: title,
        msg: text,
        icon: Ext.Msg.QUESTION,
        buttons: Ext.Msg.YESNO,
        fn: callback,
        scope: scope,
    });
};
